import React from 'react';

const NegativeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style={{'fill': 'red' }} >
    <path d="M15,7H1A1,1,0,0,0,1,9H15a1,1,0,0,0,0-2Z" />
  </svg>
);

export default NegativeIcon;
